export default __webpack_public_path__ + "static/media/kitchen2-2048w.7891f2fc.webp";